import Track from '../../utils/tracking';

function trackJSLogger() {
  return next => (action) => {
    try {
      Track.log(action.type);
      return next(action);
    } catch (err) {
      Track.warn('Error executing action');
    }
  };
}

export default trackJSLogger;
